const getters = {
  getCurrentStep: state => state.currentStep,
  getRegisterFields: state => state.registerFields,
  getErrorRegisterFields: state => state.errorRegisterFields,
  isLoading: state => state.isLoading,
  isComplete: state => state.isComplete,
}

export default getters
